import { render, staticRenderFns } from "./CommentsHistory.vue?vue&type=template&id=4e8e23ad&scoped=true"
import script from "./CommentsHistory.vue?vue&type=script&lang=js"
export * from "./CommentsHistory.vue?vue&type=script&lang=js"
import style0 from "./CommentsHistory.vue?vue&type=style&index=0&id=4e8e23ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8e23ad",
  null
  
)

export default component.exports